import React, { Component, PropTypes } from 'react';
import isEqual from 'lodash/isEqual';
import classnames from 'classnames';
import { reduxForm } from 'redux-form';
import { getQueryFromValue } from 'common/pager/utils';
import Form from 'common/pager/components/form'

/**
 * Re-usable pager component.
 * The page value is always read/updated from/to the URL query parameters.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
export default class Pager extends Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handlePrev = this.handlePrev.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.handleLast = this.handleLast.bind(this);
  }

  componentDidMount() {
    /* save initial pager query */
    const { resourceName, saveLastQuery, value } = this.props;
    const pagerQuery = getQueryFromValue(resourceName, value);
    saveLastQuery(resourceName, pagerQuery);
  }

  componentDidUpdate(prevProps) {
    const { resourceName, saveLastQuery, value } = this.props;

    /* save query when parameters are updated */
    if (!isEqual(prevProps.value, value)) {
      const pagerQuery = getQueryFromValue(resourceName, value);
      saveLastQuery(resourceName, pagerQuery);
    }
  }

  updatePage(value) {
    const { router, resourceName } = this.props;
    const currentLocation = router.getCurrentLocation();
    const pagerQuery = getQueryFromValue(resourceName, value);
    const updatedQuery = {
      ...currentLocation.query,
      ...pagerQuery
    };

    /* update URL with new query parameters */
    router.push({
      ...currentLocation,
      query: updatedQuery
    });
  }

  handleSubmit(formData) {
    this.updatePage(formData.page);
  }

  handlePrev() {
    this.updatePage(this.props.value - 1);
  }

  handleNext() {
    this.updatePage(this.props.value + 1);
  }

  handleLast() {
    this.updatePage(this.props.pageCount);
  }

  render() {
    const { resourceName, value, pageCount, className } = this.props;

    if (pageCount <= 1 && value < 2) {
      return null;
    }

    const WrappedForm = reduxForm({
      form: `${resourceName}_pager_form`,
      initialValues: { page: value },
      validate: (values) => {
        if (values.page < 1 || values.page > pageCount) {
          return { page: "Invalid page" };
        }
      }
    })(Form);

    return (
      <div className={classnames("pagination", className)}>
        <WrappedForm
          onSubmit={this.handleSubmit}
          pageCount={pageCount}
          currentPage={value}
          handlePrev={this.handlePrev}
          handleNext={this.handleNext}
          handleLast={this.handleLast}
        />
      </div>
    );
  }
}

Pager.propTypes = {
  value: PropTypes.number.isRequired,
  pageCount: PropTypes.number.isRequired,
  router: PropTypes.object.isRequired,
  resourceName: PropTypes.string.isRequired,
  saveLastQuery: PropTypes.func.isRequired,
  className: PropTypes.string
};



// WEBPACK FOOTER //
// ./common/pager/components/index.jsx